import { Helmet } from "react-helmet-async";

interface StructuredDataProps {
	type?: "Organization" | "Website" | "Article" | "Product" | "BreadcrumbList" | "SoftwareApplication";
	data: Record<string, any>;
}

const AppStructuredData = ({ type = "Website", data }: StructuredDataProps) => {
	const structuredData = {
		"@context": "https://schema.org",
		"@type": type,
		...data,
	};

	return (
		<Helmet>
			<script type="application/ld+json">
				{JSON.stringify(structuredData, null, 2)}
			</script>
		</Helmet>
	);
};

export default AppStructuredData;